export default __webpack_public_path__ + "static/media/figure9.777acd14.png";